import React, { useState } from 'react';
import { Icon } from '@iconify/react';
import { useNavigate } from 'react-router-dom';
export function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    navigate('/dashboard');
  };
  return <main className="min-h-screen w-full flex items-center justify-center px-4" style={{
    backgroundColor: '#eff0f2',
    fontFamily: 'Roboto, sans-serif'
  }} data-id="element-1505">
      {/* Centered Card */}
      <div className="bg-white w-full" style={{
      maxWidth: '380px',
      boxShadow: 'none',
      border: '1px solid #E4E4E4',
      borderRadius: '8px',
      padding: '40px 24px 36px'
    }} data-id="element-1506">
        {/* Logo */}
        <div className="flex justify-center mb-8" data-id="element-1507">
          <img src="https://dev.bandiperchicrea.it/images/logo_dark.svg" alt="Per Chi Crea" style={{
          height: '72px',
          width: 'auto'
        }} data-id="element-1508" />
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} data-id="element-1509">
          {/* Email Field */}
          <div className="mb-4" data-id="element-1510">
            <label htmlFor="email" className="block mb-1 text-[#293B54]" style={{
            fontSize: '14px'
          }} data-id="element-1511">
              Email
            </label>
            <input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} className="w-full outline-none transition-colors" style={{
            height: '40px',
            padding: '0 10px',
            border: '1px solid #E4E4E4',
            borderRadius: '9999px',
            fontSize: '14px',
            fontFamily: 'Roboto, sans-serif'
          }} onFocus={e => e.target.style.borderColor = '#2A97DF'} onBlur={e => e.target.style.borderColor = '#E4E4E4'} data-id="element-1512" />
          </div>

          {/* Password Field */}
          <div className="mb-3" data-id="element-1513">
            <label htmlFor="password" className="block mb-1 text-[#293B54]" style={{
            fontSize: '14px'
          }} data-id="element-1514">
              Password
            </label>
            <div className="relative" data-id="element-1515">
              <input id="password" type={showPassword ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} className="w-full outline-none transition-colors" style={{
              height: '40px',
              padding: '0 36px 0 10px',
              border: '1px solid #E4E4E4',
              borderRadius: '9999px',
              fontSize: '14px',
              fontFamily: 'Roboto, sans-serif'
            }} onFocus={e => e.target.style.borderColor = '#2A97DF'} onBlur={e => e.target.style.borderColor = '#E4E4E4'} data-id="element-1516" />
              <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-2 top-1/2 -translate-y-1/2 transition-colors" style={{
              color: '#AAAAAA'
            }} aria-label={showPassword ? 'Nascondi password' : 'Mostra password'} data-id="element-1517">
                {showPassword ? <Icon icon="tabler:eye" fontSize={18} data-id="element-1518" /> : <Icon icon="tabler:eye-off" fontSize={18} data-id="element-1519" />}
              </button>
            </div>
          </div>

          {/* Forgot Password */}
          <div className="mb-5" data-id="element-1520">
            <a href="#" className="hover:underline text-[#293B54]" style={{
            fontSize: '13px'
          }} data-id="element-1521">
              Password dimenticata?
            </a>
          </div>

          {/* Login Button */}
          <button type="submit" className="w-full transition-colors hover:opacity-90" style={{
          height: '44px',
          backgroundColor: '#293B54',
          color: '#FFFFFF',
          borderRadius: '9999px',
          fontFamily: 'Roboto Condensed, sans-serif',
          fontSize: '14px',
          fontWeight: 400,
          border: 'none',
          cursor: 'pointer'
        }} data-id="element-1522">
            Login
          </button>

          {/* No registrations warning */}
          <div className="flex items-center gap-2 mt-5 mb-5" style={{
          padding: '10px 14px',
          backgroundColor: '#FFF8F0',
          border: '1px solid #E96E00',
          borderRadius: '6px'
        }} data-id="element-1523">
            <Icon icon="tabler:alert-triangle" fontSize={18} style={{
            color: '#E96E00',
            flexShrink: 0
          }} data-id="element-1524" />
            <span style={{
            fontSize: '13px',
            color: '#293B54',
            fontFamily: 'Roboto, sans-serif',
            lineHeight: '1.4',
            fontWeight: 500
          }} data-id="element-1525">
              Al momento non sono ammesse nuove registrazioni
            </span>
          </div>

          {/* Manual section */}
          <p className="text-center mt-5" style={{
          fontSize: '14px',
          color: '#80858E',
          fontFamily: 'Roboto, sans-serif',
          fontWeight: 400,
          lineHeight: '1.5'
        }} data-id="element-1526">
            Per consultare il manuale di utilizzo della piattaforma
          </p>

          {/* CLICCA QUI button */}
          <button type="button" className="w-full mt-3 transition-colors hover:bg-[#293B54] hover:text-white" style={{
          height: '44px',
          backgroundColor: 'transparent',
          color: '#293B54',
          borderRadius: '9999px',
          border: '1px solid #293B54',
          fontFamily: 'Roboto Condensed, sans-serif',
          fontSize: '14px',
          fontWeight: 400,
          cursor: 'pointer'
        }} data-id="element-1527">
            Clicca qui
          </button>
        </form>
      </div>

      {/* INVIA SEGNALAZIONE - fixed bottom right */}
      <div className="fixed bottom-4 right-4 md:bottom-0 md:right-0" style={{
      zIndex: 50
    }} data-id="element-1528">
        <button type="button" className="transition-colors hover:bg-gray-50" style={{
        padding: '8px 16px',
        backgroundColor: '#FFFFFF',
        color: '#293B54',
        border: '1px solid #E4E4E4',
        borderRadius: '8px',
        fontFamily: 'Roboto Condensed, sans-serif',
        fontSize: '14px',
        fontWeight: 400,
        cursor: 'pointer',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }} data-id="element-1529">
          Invia segnalazione
        </button>
      </div>
    </main>;
}